import {
  FC,
  ReactElement,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react';
import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';

type RenderProps = {
  open: () => void;
  close: () => void;
  itemClassName: string;
};
type Props = {
  children: ReactNode | ((props: RenderProps) => ReactElement);
};
const MenuButton: FC<Props> = ({ children }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isVisiblePopUp, setIsVisiblePopUp] = useState(false);
  const open = () => {
    setIsVisiblePopUp(true);
  };
  const close = () => {
    setIsVisiblePopUp(false);
  };
  useEffect(() => {
    const handler = (event: MouseEvent) => {
      // 自身の子孫のクリックでは閉じないようにする
      if (
        event.target instanceof Node &&
        containerRef.current?.contains(event.target)
      )
        return;
      // その他のクリックでは閉じる
      close();
    };

    // 他の処理に割り込まれないようにキャプチャーフェーズにイベントを仕掛ける
    window.addEventListener('click', handler, { capture: true });
    return () =>
      window.removeEventListener('click', handler, { capture: true });
  });
  return (
    <div
      ref={containerRef}
      className={styles.container}
      onClick={(e) => e.stopPropagation()}
    >
      <button className={styles.menuButton} onClick={open}>
        <FontAwesomeIcon icon={faEllipsis} className={styles.ellipsis} />
      </button>
      {isVisiblePopUp && (
        <div className={styles.menuBackground}>
          {typeof children === 'function'
            ? children({ open, close, itemClassName: styles.menuItem })
            : children}
        </div>
      )}
    </div>
  );
};

export default MenuButton;
